import { defineFilterConfig, filterFieldAdapters } from "@src/components/business-form";
import type { StockGatheringFilter } from "../../../../../../api/stockGatherings";

/** Значения формы фильтра списка КВ для комплектования. */
export interface StockGatheringCompletionFilterFormValues {
    /** Номер КВ. */
    num: string;
    /** Код склада-отправителя. */
    senderDivisionCode: number | null;
    /** Код цеха-получателя. */
    receiverDivisionCode: number | null;
    /** Код участка-получателя. */
    receiverSectionCode: number | null;
    /** Коды статусов КВ. */
    stateCodes: number[];
}

/** Конфигурация фильтра списка КВ для комплектования. */
export const stockGatheringCompletionFilterFormConfig = defineFilterConfig<
    StockGatheringCompletionFilterFormValues,
    StockGatheringFilter
>({
    fields: {
        senderDivisionCode: {
            type: "number",
            nullable: true,
            label: "Склад-отправитель",
            validation: { required: true },
            map: filterFieldAdapters.singleCodeArray("SenderDivisionCodes"),
        },
        num: {
            type: "string",
            label: "Номер КВ",
            map: {
                from: (domain) => domain.Num ?? "",
                to: (value) => {
                    const trimmed = value.trim();
                    return { Num: trimmed === "" ? undefined : trimmed };
                },
            },
        },
        receiverDivisionCode: {
            type: "number",
            nullable: true,
            label: "Цех-получатель",
            // validation: { required: true },
            map: filterFieldAdapters.singleCodeArray("ReceiverDivisionCodes"),
        },
        receiverSectionCode: {
            type: "number",
            nullable: true,
            label: "Участок-получатель",
            /**
             * Зависит от цеха-получателя: без выбранного цеха участок недоступен. \
             * TODO(forms/spp-lib): заменить на `dependsOn` (+ clearOnChange) в shared form engine;
             * сейчас clear — ручной `onChange` в {@link StockGatheringCompletionFilterForm}.
             */
            disabled: (values) => values.receiverDivisionCode == null || values.receiverDivisionCode === 0,
            map: filterFieldAdapters.singleCodeArray("ReceiverSectionCodes"),
        },
        stateCodes: {
            type: "array",
            label: "Статусы КВ",
            map: filterFieldAdapters.entityCodes("StateCodes"),
        },
    },
});
